<template>
  <v-container class="py-0">
    <!-- 1 ETAPA WIZZARD (INÍCIO) -->
    <v-tab-item eager>
      <informacoes-gerais
        ref="InformacoesGerais"
        @step-observer-nome="validInputsInfoGerais"
        @step-observer-empresa="validInputsInfoGerais"
        @step-observer-data-inicio="validInputsInfoGerais"
        @step-observer-data-final="validInputsInfoGerais"
      />
    </v-tab-item>
    <!-- 2 ETAPA WIZZARD (UPLOAD DE ARQUIVOS) -->
    <v-tab-item eager>
      <upload-files-bulldozerr
        ref="UploadFilesBulldozerr"
        @step-observer-files="validInputsFiles"
      />
    </v-tab-item>
    <!-- 3 ETAPA WIZZARD (ICMS) -->
    <v-tab-item eager>
      <informacoes-icms
        ref="InformacoesIcms"
        @step-observer-recuperacao-analise="validInputsInfoIcms"
      />
    </v-tab-item>
    <!-- 4 ETAPA WIZZARD (BANCO DE COMPRAS) -->
    <v-tab-item eager>
      <informacoes-banco-compras
        ref="InformacoesBancoCompras"
        @step-observer-fluxo-pagamento="validInputsInfoBancoCompras"
        @step-observer-valor-odc="validInputsInfoBancoCompras"
      />
    </v-tab-item>
    <!-- 5 ETAPA WIZZARD (BASE FISICA BDGD) -->
    <v-tab-item eager>
      <informacoes-bdgd
        ref="InformacoesBdgd"
      />
    </v-tab-item>
    <!-- 6 ETAPA WIZZARD (AIS) -->
    <v-tab-item eager>
      <informacoes-ais
        ref="InformacoesAis"
      />
    </v-tab-item>
    <!-- 7 ETAPA WIZZARD (BASE INCREMENTAL) -->
    <v-tab-item eager>
      <informacoes-base-incremental
        ref="InformacoesBaseIncremental" 
      />
    </v-tab-item>
    <!-- 8 ETAPA WIZZARD (OBRIGAÇÕES ESPECIAIS) -->
    <v-tab-item eager>
      <informacoes-obrigacoes-especiais
        ref="InformacoesObrigacoesEspeciais" 
        @step-observer-calculo-amortizacao="validInputsObrigacoesEspeciais"
      />
    </v-tab-item>
  </v-container>
</template>

<script>
export default {
  components: {
    ValidationHelper:               () => import('@/components/general/ValidationHelper.vue'),
    UploadFilesBulldozerr:          () => import('@/components/bulldozerr/wizards/UploadFiles.vue'),
    InformacoesGerais:              () => import('@/components/bulldozerr/wizards/InformacoesGerais.vue'),
    InformacoesIcms:                () => import('@/components/bulldozerr/wizards/InformacoesIcms.vue'),
    InformacoesBancoCompras:        () => import('@/components/bulldozerr/wizards/InformacoesBancoCompras.vue'),
    InformacoesBdgd:                () => import('@/components/bulldozerr/wizards/InformacoesBdgd.vue'),
    InformacoesAis:                 () => import('@/components/bulldozerr/wizards/InformacoesAis.vue'),
    InformacoesBaseIncremental:     () => import('@/components/bulldozerr/wizards/InformacoesBaseIncremental.vue'),
    InformacoesObrigacoesEspeciais: () => import('@/components/bulldozerr/wizards/InformacoesObrigacoesEspeciais.vue')
  },

  data() {
    return {
      infosGeral: {
        nomeValid: false,
        empresaValid: false,
        dataInicioValid: false,
        dataFinalValid: false
      },
      infosIcms: {
        recuperacaoAnaliseValid: false
      },
      infosBancoCompras: {
        valorOdcValid: false,
        fluxoPagamentoValid: false
      },
      infoObrigacoesEspeciais: {
        calculoAmortizacaoValid: false
      }
    };
  },

  methods: {
    saveData() {
      let caminhoTmpUpload = this.$refs.UploadFilesBulldozerr.caminhoTmp;
      let informacoesGerais = this.$refs.InformacoesGerais.exportData();
      let informacoesIcms = this.$refs.InformacoesIcms.exportData();
      let informacoesBancoCompras = this.$refs.InformacoesBancoCompras.exportData();
      let informacoesBdgd = this.$refs.InformacoesBdgd.exportData();
      let informacoesAis = this.$refs.InformacoesAis.exportData();
      let informacoesBaseIncremental = this.$refs.InformacoesBaseIncremental.exportData();
      let informacoesObrigacoesEspeciais = this.$refs.InformacoesObrigacoesEspeciais.exportData();

      return {
        informacoesGerais: informacoesGerais,
        informacoesIcms: informacoesIcms,
        informacoesBancoCompras: informacoesBancoCompras,
        informacoesBdgd: informacoesBdgd,
        informacoesAis: informacoesAis,
        informacoesBaseIncremental: informacoesBaseIncremental,
        informacoesObrigacoesEspeciais: informacoesObrigacoesEspeciais,
        caminhoTmpUpload: caminhoTmpUpload
      };
    },

    validInputsInfoGerais(event) {
      switch (event.step) {
      case 'nome':
        this.infosGeral.nomeValid = event.complete;
        break;
      case 'empresa':
        this.infosGeral.empresaValid = event.complete;
        break;
      case 'data-inicio':
        this.infosGeral.dataInicioValid = event.complete;
        break;
      case 'data-final':
        this.infosGeral.dataFinalValid = event.complete;
        break;
      }

      if (
        this.infosGeral.nomeValid &&
        this.infosGeral.empresaValid &&
        this.infosGeral.dataInicioValid &&
        this.infosGeral.dataFinalValid
      ) {
        this.$emit('step-observer', { step: 0, complete: true });
      } else {
        this.$emit('step-observer', { step: 0, complete: false });
      }
    },

    validInputsInfoIcms(event) {
      switch (event.step) {
      case 'recuperacao-analise':
        this.infosIcms.recuperacaoAnaliseValid = event.complete;
        break;
      }

      if (this.infosIcms.recuperacaoAnaliseValid) {
        this.$emit('step-observer', { step: 2, complete: true });
      } else {
        this.$emit('step-observer', { step: 2, complete: false });
      }
    },

    validInputsFiles(event) {
      this.$emit('step-observer', event);
    },

    validInputsInfoBancoCompras(event) {
      switch (event.step) {
      case 'valor-odc':
        this.infosBancoCompras.valorOdcValid = event.complete;
        break;
      case 'fluxo-pagamento':
        this.infosBancoCompras.fluxoPagamentoValid = event.complete;
        break;
      }

      if (this.infosBancoCompras.valorOdcValid && this.infosBancoCompras.fluxoPagamentoValid) {
        this.$emit('step-observer', { step: 3, complete: true });
        this.$emit('step-observer', { step: 4, complete: true });
        this.$emit('step-observer', { step: 5, complete: true });
        this.$emit('step-observer', { step: 6, complete: true });
      } else {
        this.$emit('step-observer', { step: 3, complete: false });
      }
    },
    
    validInputsObrigacoesEspeciais(event) {

      switch (event.step) {
      case 'calculo-amortizacao':
        this.infoObrigacoesEspeciais.calculoAmortizacaoValid = event.complete;
        break;
      }

      if (this.infoObrigacoesEspeciais.calculoAmortizacaoValid) {
        this.$emit('step-observer', { step: 7, complete: true });
      } else {
        this.$emit('step-observer', { step: 7, complete: false });
      }
    }
  }
};
</script>